

















































































/** @format */

import { Vue, Component, Mixins } from 'vue-property-decorator';
import ParkingLotSearch from '../../../components/parking-lot-search/index.vue';

import TableMixin from '@root/common/mixins/table';
import TableWidthMixin from '@root/common/mixins/table-width';
import { baseParkEvent, exportBaseParkEvent } from '@/api/parking-lot-management/index';
import { dictChannelTypeMap } from '@/types/parking-lot-management/dictionaries';
import Utils from '@root/utils/common';
import moment from 'moment';
// 字典
import { eventTypeMap } from '@/types/parking-lot-management/dictionaries';
import { Getter } from 'vuex-class';
import * as _ from 'lodash';
@Component({
  name: 'EventRecord',
  components: { ParkingLotSearch }
})
// @ts-ignore
export default class EventRecord extends Mixins(TableMixin, TableWidthMixin) {
  // 操作类型
  private current = 1;
  private moment = moment;
  private eventTypeList = Utils.toLabelVal(eventTypeMap);
  private filterParam: any = {
    parkIds: [], // 车场ID集合,多车场逗号分隔
    alarmStartTime: moment()
      .startOf('d')
      .format('YYYY-MM-DD HH:mm:ss'), // 报警时间-开始
    alarmEndTime: moment()
      .startOf('d')
      .format('YYYY-MM-DD 23:59:59'), // 报警时间-结束
    types: [], // 事件类型
    deviceType: '', //设备类型
    channelType: '',
    channelName: ''
  };
  private tableLoading = false;
  private tableData: any[] = []; // 表数据
  downloadFlag: boolean = false;
  channelTypeOptions: IOption[] = Utils.toLabelVal(dictChannelTypeMap);
  get defaultTime() {
    if (this.filterParam.alarmStartTime && this.filterParam.alarmEndTime) {
      return [
        this.moment(this.filterParam.alarmStartTime, 'YYYY-MM-DD HH:mm:ss'),
        this.moment(this.filterParam.alarmEndTime, 'YYYY-MM-DD HH:mm:ss')
      ];
    }
    if (this.filterParam.alarmStartTime) {
      return [this.moment(this.filterParam.alarmStartTime, 'YYYY-MM-DD HH:mm:ss').startOf('d')];
    } else {
      return [];
    }
  }
  set defaultTime(val: any) {}
  // 表字段说明
  get tableColums() {
    return [
      {
        title: '序号',
        width: 80,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '停车场名称',
        dataIndex: 'parkName',
        width: 200,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '事件类型',
        dataIndex: 'type',
        width: 160,
        customRender: (text: any) => eventTypeMap[text] || '--'
      },
      {
        title: '设备类型',
        dataIndex: 'deviceTypeName',
        width: 160,
        customRender: (text: any) => text || '--'
      },
      {
        title: '事件描述',
        dataIndex: 'description',
        width: 240,
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '告警时间',
        dataIndex: 'alarmTime',
        width: 200,
        customRender: (text: any) => text || '--'
      }
      // {
      //   title: '本次离线时长',
      //   dataIndex: 'breakOff',
      //   width: 200,
      //   scopedSlots: { customRender: 'text-ellipse-to-tip' }
      // }
    ];
  }
  //判断是否存在并push
  judgeIs(list, id) {
    const index = list.findIndex(item => item.value == id);
    if (index > -1) {
      list.unshift(list[index]);
    }
  }
  // 设备类型下拉框
  @Getter('dictionaries/deviceType')
  deviceTypeMap?: object;
  get typeOptions(): any[] {
    const typeArr = Utils.toLabelVal(this.deviceTypeMap || {});
    if (!this.isWenLv) {
      this.judgeIs(typeArr, '08');
      this.judgeIs(typeArr, '12');
      this.judgeIs(typeArr, '10');
      this.judgeIs(typeArr, '09');
      this.judgeIs(typeArr, '03');
      this.judgeIs(typeArr, '02');
      this.judgeIs(typeArr, '01');
    }
    return _.uniq(typeArr);
    // return typeArr.sort(Utils.compare('value')) || []
  }
  created() {
    this.fetchTableData();
  }

  async fetchTableData(refresh?: any) {
    if (refresh) this.current = 1;
    if (this.tableLoading) return;
    this.tableLoading = true;
    try {
      const { parkIds, types, ...rest } = this.filterParam;
      const { status, code, msg, data } = await baseParkEvent({
        ...rest,
        parkIds: parkIds.join(','),
        types: types.join(','),
        currPage: this.current,
        pageSize: this.pageSize
      });
      const { pageSize = 0, currPage = 0, totalPage, totalNum = 0, datas = [], total } = data;
      this.total = +totalNum;
      this.tableData = datas;
      this.total = +totalNum;
      this.current = +currPage;
      this.pageSize = +pageSize;
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }
  /**
   * 点击搜索按钮
   */
  private search() {
    this.fetchTableData(true);
  }
  /**
   * 点击清除按钮
   **/

  private clear({ defaultParkIdList }) {
    this.filterParam = {
      parkIds: defaultParkIdList,
      alarmStartTime: moment()
        .startOf('d')
        .format('YYYY-MM-DD HH:mm:ss'),
      alarmEndTime: moment()
        .startOf('d')
        .format('YYYY-MM-DD 23:59:59'),
      types: []
    };
    this.fetchTableData();
  }

  // 入场时间改变
  onEnterTimeChange(date: any, dateString: any) {
    let [startTime, endTime] = dateString;
    this.filterParam.alarmStartTime = startTime;
    this.filterParam.alarmEndTime = endTime;
  }
  //分页
  handleTableChange(val: any) {
    this.current = val.current;
    this.pageSize = val.pageSize;
    this.fetchTableData();
  }
  /**
   * 导出
   */
  private async download() {
    try {
      const {
        parkIds = [],
        types = [],
        alarmStartTime = '',
        alarmEndTime = '',
        deviceType = '',
        channelName = '',
        channelType = ''
      } = this.filterParam;
      const { current = '', pageSize = '' } = this;
      const params = {
        parkIds: parkIds.join(','),
        types: types.join(','),
        alarmStartTime,
        alarmEndTime,
        currPage: current,
        pageSize,
        deviceType,
        channelName,
        channelType
      };
      if (this.downloadFlag) return;
      this.downloadFlag = true;
      await exportBaseParkEvent(
        {
          ...params
        },
        '车场事件记录'
      );
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.downloadFlag = false;
    }
  }
}
